var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { HotelTopAmenities, HotelRoomRateTopAmenities, CurrencyMap, } from "@travel/shared/types";
import { parsePPNDate, formatURLDate, santizePPNPolicyText, mutateAddress, } from "@travel/shared/utils";
import { transformPrice } from "@travel/shared/currency/utils";
import { mutateReview } from "@travel/shared/reviews/utils";
import { computeHotelDiscountPrice, computeHotelDiscountTotalPriceV2, } from "./compute";
export function getLowestRatePrice(data, currency) {
    var e_1, _a, e_2, _b;
    var _c;
    if (currency === void 0) { currency = "usd"; }
    var lowestHotelPrice = {};
    var lowestPrice = Infinity;
    try {
        for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
            var rates = data_1_1.value.rates;
            try {
                for (var rates_1 = (e_2 = void 0, __values(rates)), rates_1_1 = rates_1.next(); !rates_1_1.done; rates_1_1 = rates_1.next()) {
                    var rate = rates_1_1.value;
                    var ratePrice = ((_c = rate.price.display) === null || _c === void 0 ? void 0 : _c.value) || Infinity;
                    if (!lowestPrice || lowestPrice > ratePrice) {
                        lowestPrice = ratePrice;
                        lowestHotelPrice = rate.price;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (rates_1_1 && !rates_1_1.done && (_b = rates_1.return)) _b.call(rates_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return lowestHotelPrice;
}
function ensureHTTPS(src) {
    if (src === void 0) { src = ""; }
    var _a = __read(src.split("//"), 2), protocol = _a[0], url = _a[1];
    if (protocol !== "https") {
        return "https://".concat(url);
    }
    return src;
}
export function transformHotel(data, meta) {
    var e_3, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var thumbnail = ((_b = data === null || data === void 0 ? void 0 : data.thumbnail_hq) === null || _b === void 0 ? void 0 : _b.three_hundred_square) || (data === null || data === void 0 ? void 0 : data.thumbnail);
    var rooms = ((_c = data === null || data === void 0 ? void 0 : data.room_data) === null || _c === void 0 ? void 0 : _c.map(function (room) { return transformHotelRoom(room, null, meta); })) ||
        [];
    var rateOptions = getRateOptions(rooms);
    var address = data.address || data;
    var guestScores = __assign(__assign({}, data === null || data === void 0 ? void 0 : data.guest_score_categories), data === null || data === void 0 ? void 0 : data.review_score_data);
    var price = data.room_data_price
        ? mutateHotelPrice(data.room_data_price, null, meta)
        : getLowestRatePrice(rooms);
    var hasFreeCancellation = ((_d = data === null || data === void 0 ? void 0 : data.room_data_price) === null || _d === void 0 ? void 0 : _d.is_cancellable) || false;
    var hasPayLater = ((_e = data === null || data === void 0 ? void 0 : data.room_data_price) === null || _e === void 0 ? void 0 : _e.postpaid) || false;
    try {
        for (var rateOptions_1 = __values(rateOptions), rateOptions_1_1 = rateOptions_1.next(); !rateOptions_1_1.done; rateOptions_1_1 = rateOptions_1.next()) {
            var rateOption = rateOptions_1_1.value;
            switch (rateOption.id) {
                case "postpaid":
                    hasPayLater = true;
                    break;
                case "free-cancellation":
                    hasFreeCancellation = true;
                    break;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (rateOptions_1_1 && !rateOptions_1_1.done && (_a = rateOptions_1.return)) _a.call(rateOptions_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var cleanliness = Number(guestScores.cleanliness || guestScores.cleanliness_score) || 0;
    var location = Number(guestScores.location || guestScores.location_score) || 0;
    var staff = Number(guestScores.staff || guestScores.staff_score) || 0;
    var hotel = {
        id: (data === null || data === void 0 ? void 0 : data.id) || (data === null || data === void 0 ? void 0 : data.hotelid_ppn) || (data === null || data === void 0 ? void 0 : data.hotel_id),
        name: (data === null || data === void 0 ? void 0 : data.name) || (data === null || data === void 0 ? void 0 : data.hotel_name) || "",
        description: (data === null || data === void 0 ? void 0 : data.hotel_description) || (data === null || data === void 0 ? void 0 : data.property_description) || "",
        type: data === null || data === void 0 ? void 0 : data.hotel_type,
        address: mutateAddress(__assign(__assign(__assign({}, address), data.geo), { cityID: address.city_id || ((_f = data.city) === null || _f === void 0 ? void 0 : _f.id) })),
        phone: {
            number: (data === null || data === void 0 ? void 0 : data.phone) || (data === null || data === void 0 ? void 0 : data.phone_number),
        },
        price: price,
        starRating: data === null || data === void 0 ? void 0 : data.star_rating,
        reviewRating: data === null || data === void 0 ? void 0 : data.review_rating,
        reviewRatingDescription: data === null || data === void 0 ? void 0 : data.review_rating_desc,
        reviewScores: {
            cleanliness: cleanliness,
            location: location,
            staff: staff,
        },
        reviewCount: data === null || data === void 0 ? void 0 : data.review_count,
        thumbnail: thumbnail
            ? {
                type: "image",
                src: ensureHTTPS(thumbnail),
            }
            : null,
        images: Array.isArray(data === null || data === void 0 ? void 0 : data.photo_data)
            ? data === null || data === void 0 ? void 0 : data.photo_data.map(function (src) { return ({
                src: ensureHTTPS(src),
                type: "image",
            }); })
            : (data === null || data === void 0 ? void 0 : data.photo_data)
                ? Object.keys(data === null || data === void 0 ? void 0 : data.photo_data).map(function (key) { return ({
                    type: "image",
                    src: ensureHTTPS(data === null || data === void 0 ? void 0 : data.photo_data[key]),
                }); })
                : [],
        amenities: data === null || data === void 0 ? void 0 : data.amenity_data,
        topAmenities: getTopAmenities(data === null || data === void 0 ? void 0 : data.amenity_data),
        topBookReasons: [],
        neighborhood: data === null || data === void 0 ? void 0 : data.neighborhood,
        brand: {
            id: (_g = data === null || data === void 0 ? void 0 : data.hotel_chain) === null || _g === void 0 ? void 0 : _g.id,
            name: (_h = data === null || data === void 0 ? void 0 : data.hotel_chain) === null || _h === void 0 ? void 0 : _h.name,
            value: (_j = data === null || data === void 0 ? void 0 : data.hotel_chain) === null || _j === void 0 ? void 0 : _j.id,
        },
        reviews: (_k = data === null || data === void 0 ? void 0 : data.review_data) === null || _k === void 0 ? void 0 : _k.map(transformHotelReview),
        checkIn: (data === null || data === void 0 ? void 0 : data.check_in) || (data === null || data === void 0 ? void 0 : data.check_in_time),
        checkOut: (data === null || data === void 0 ? void 0 : data.check_out) || (data === null || data === void 0 ? void 0 : data.check_out_time),
        rooms: rooms,
        roomCount: data === null || data === void 0 ? void 0 : data.room_count,
        rateOptions: rateOptions,
        importantInfo: parseTextContent(data === null || data === void 0 ? void 0 : data.important_information),
        isPetFriendly: !!((_l = data === null || data === void 0 ? void 0 : data.amenity_data) === null || _l === void 0 ? void 0 : _l.find(function (_a) {
            var id = _a.id;
            return Number(id) === 13;
        })),
        hasFreeCancellation: hasFreeCancellation,
        hasPayLater: hasPayLater,
        hasFreeWifi: !!((_m = data === null || data === void 0 ? void 0 : data.amenity_data) === null || _m === void 0 ? void 0 : _m.find(function (_a) {
            var id = _a.id;
            return Number(id) === 1556;
        })),
        hasBetterDeal: !!(data === null || data === void 0 ? void 0 : data.betterDealAvailable) ||
            !!price.hasBetterDeal ||
            !!rooms.find(function (room) { return room.hasBetterDeal; }),
    };
    hotel.topBookReasons = getTopBookReasons(hotel);
    return hotel;
}
export function transformHotelRoom(data, hotel, meta) {
    var _a, _b, _c, _d, _e, _f;
    var rates = ((_a = data === null || data === void 0 ? void 0 : data.rate_data) === null || _a === void 0 ? void 0 : _a.map(function (rate) { return transformHotelRoomRate(rate, meta); })) ||
        [];
    return {
        id: (data === null || data === void 0 ? void 0 : data.id) || ((_c = (_b = data === null || data === void 0 ? void 0 : data.rate_data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.room_id),
        name: (data === null || data === void 0 ? void 0 : data.title) || ((_e = (_d = data === null || data === void 0 ? void 0 : data.rate_data) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.title),
        description: (data === null || data === void 0 ? void 0 : data.description) || "",
        rates: rates,
        size: (data === null || data === void 0 ? void 0 : data.room_square_footage) || 0,
        amenities: (data === null || data === void 0 ? void 0 : data.amenities) || [],
        topAmenities: [],
        occupancyLimit: (_f = rates === null || rates === void 0 ? void 0 : rates[0]) === null || _f === void 0 ? void 0 : _f.occupancyLimit,
        photos: parsePhotos(data === null || data === void 0 ? void 0 : data.photos),
        hasBetterDeal: data === null || data === void 0 ? void 0 : data.betterDealAvailable,
        bedding: mutateHotelRoomBedding(data),
    };
}
function parsePhotos(photos) {
    return ((photos === null || photos === void 0 ? void 0 : photos.reduce(function (acc, photo) {
        var src = (photo === null || photo === void 0 ? void 0 : photo.large) || (photo === null || photo === void 0 ? void 0 : photo.medum) || (photo === null || photo === void 0 ? void 0 : photo.small);
        if (src) {
            acc.push({
                src: ensureHTTPS(src),
                type: "image",
            });
        }
        return acc;
    }, [])) || []);
}
export function mutateHotelRoomBedding(data) {
    var _a, _b;
    return (_b = (_a = data === null || data === void 0 ? void 0 : data.bedding_data) === null || _a === void 0 ? void 0 : _a.areas) === null || _b === void 0 ? void 0 : _b.reduce(function (acc, beddingData) {
        var _a;
        if (beddingData.bed_groups) {
            var type = computeHotelBedroomName(beddingData.type);
            acc.push({
                type: type,
                beds: (_a = beddingData.bed_groups) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, bedGroup) {
                    if (bedGroup.beds.length) {
                        acc.push.apply(acc, __spreadArray([], __read(bedGroup.beds), false));
                    }
                    return acc;
                }, []),
            });
        }
        return acc;
    }, []);
}
var DEFAULT_HOTEL_BEDROOM_NAME = "Bedroom";
export function computeHotelBedroomName(name) {
    if (!name || typeof name !== "string")
        return DEFAULT_HOTEL_BEDROOM_NAME;
    switch (name.toLowerCase()) {
        case "null":
        case "unknown":
        case "undefined":
            return DEFAULT_HOTEL_BEDROOM_NAME;
    }
    return name;
}
export function transformHotelRoomRate(data, meta) {
    var _a, _b, _c, _d;
    var isMemberDeal = ((_a = data === null || data === void 0 ? void 0 : data.program_types) === null || _a === void 0 ? void 0 : _a.find(function (type) { var _a; return (_a = type === null || type === void 0 ? void 0 : type.match) === null || _a === void 0 ? void 0 : _a.call(type, /MEMBER_DEAL/gi); })) || false;
    var isVIPDeal = !!((_b = data === null || data === void 0 ? void 0 : data.rate_type) === null || _b === void 0 ? void 0 : _b.match(/SMOP/gi)) || false;
    var isDeal = isMemberDeal || isVIPDeal;
    return {
        id: data.ppn_bundle_id || data.ppn_bundle,
        price: mutateHotelPrice(data.price_details, data.benchmark_price_details, meta),
        amenities: (data === null || data === void 0 ? void 0 : data.rate_amenity_data) || [],
        topAmenities: ((_c = data === null || data === void 0 ? void 0 : data.rate_amenity_data) === null || _c === void 0 ? void 0 : _c.filter(function (amenity) {
            return HotelRoomRateTopAmenities.indexOf(amenity.toUpperCase()) > -1;
        })) || [],
        paymentType: data.payment_type,
        occupancyLimit: data.occupancy_limit,
        policies: parseTextContent(data === null || data === void 0 ? void 0 : data.policy_data),
        availableRoomCount: (data === null || data === void 0 ? void 0 : data.available_rooms) || 0,
        isDeal: isDeal,
        isMemberDeal: isMemberDeal,
        isVIPDeal: isVIPDeal,
        isCancellable: (data === null || data === void 0 ? void 0 : data.is_cancellable) !== "false",
        isFullyRefundable: !((_d = data === null || data === void 0 ? void 0 : data.refund_type) === null || _d === void 0 ? void 0 : _d.match(/NONE/i)) || false,
        isBreakfastIncluded: false,
        cancellationPolicies: mutateHotelCancellationPolicies(data.cancellation_details),
    };
}
export function mutateHotelCancellationPolicies(data) {
    return data === null || data === void 0 ? void 0 : data.map(function (_a) {
        var description = _a.description, date_before = _a.date_before, date_after = _a.date_after, rest = __rest(_a, ["description", "date_before", "date_after"]);
        return (__assign(__assign({}, mutateHotelPrice(rest)), { description: description, from: date_after, to: date_before }));
    });
}
export function mutateHotelPrice(data, benchmark, _a) {
    if (data === void 0) { data = {}; }
    if (benchmark === void 0) { benchmark = {}; }
    var _b = _a === void 0 ? {} : _a, _c = _b.nightsCount, nightsCount = _c === void 0 ? 1 : _c, _d = _b.roomCount, roomCount = _d === void 0 ? 1 : _d;
    var displayPrice = data.display_price || data.display_amount;
    var displayTotal = data.display_total || data.display_total_charges;
    var displaySavings = data.saving_percentage || (benchmark === null || benchmark === void 0 ? void 0 : benchmark.saving_percentage) || 0;
    var discountPrice = computeHotelDiscountTotalPriceV2(displayPrice, (benchmark === null || benchmark === void 0 ? void 0 : benchmark.display_price) || (data === null || data === void 0 ? void 0 : data.original_price), nightsCount, roomCount);
    var taxes = data.display_tax || data.display_taxes;
    var originalTotal = data.original_total ||
        (function () {
            return displayTotal + discountPrice;
        })();
    var currency = data.display_currency;
    var isDiscount = displaySavings > 0;
    var mandatoryFees = mutateMandatoryFees(data);
    return {
        display: transformPrice(displayPrice, currency),
        displayTaxes: transformPrice(taxes, data.display_currency),
        displayPropertyFee: transformPrice(data.display_property_fee, data.display_currency),
        displaySubtotal: transformPrice(data.display_subtotal || data.display_sub_total, currency),
        displayTotal: transformPrice(displayTotal, data.display_currency),
        displayTotalWithTaxesFees: transformPrice(data.display_all_in_total || displayTotal, currency),
        displayRefund: transformPrice(data.display_refund, data.display_currency),
        displayProcessingFee: transformPrice(data.display_processing_fee, currency),
        displayCancellationFee: transformPrice(data.display_cancellation_fee, currency),
        displayOriginal: transformPrice(data.original_price || (benchmark === null || benchmark === void 0 ? void 0 : benchmark.display_price), currency),
        displayOriginalTotal: transformPrice(originalTotal, currency),
        displaySavings: displaySavings,
        displayDiscount: transformPrice(isDiscount
            ? computeHotelDiscountPrice(displayTotal, displaySavings, nightsCount, roomCount)
            : 0, currency),
        displayDiscountTotal: transformPrice(isDiscount ? discountPrice : 0, currency),
        isDiscount: isDiscount,
        discountType: data.isCUGPrice
            ? "cug"
            : data.isMemberPrice
                ? "member"
                : null,
        mandatoryFees: mandatoryFees,
        hasBetterDeal: !!(data === null || data === void 0 ? void 0 : data.betterDealAvailable),
    };
}
export function mutateMandatoryFees(data) {
    var _a, _b;
    var mandatoryFees = data === null || data === void 0 ? void 0 : data.mandatory_fee_details;
    var prepaid = mutatePriceSummaryFee((_a = mandatoryFees === null || mandatoryFees === void 0 ? void 0 : mandatoryFees.breakdown) === null || _a === void 0 ? void 0 : _a.prepaid);
    var postpaid = mutatePriceSummaryFee((_b = mandatoryFees === null || mandatoryFees === void 0 ? void 0 : mandatoryFees.breakdown) === null || _b === void 0 ? void 0 : _b.postpaid);
    return {
        displayTotal: transformPrice(mandatoryFees === null || mandatoryFees === void 0 ? void 0 : mandatoryFees.display_total, mandatoryFees === null || mandatoryFees === void 0 ? void 0 : mandatoryFees.display_currency),
        prepaid: prepaid,
        postpaid: postpaid,
    };
}
export function mutatePriceSummaryFee(data) {
    var _a;
    return {
        displayTotal: transformPrice(data === null || data === void 0 ? void 0 : data.display_total, data === null || data === void 0 ? void 0 : data.display_currency),
        fees: (_a = data === null || data === void 0 ? void 0 : data.breakdown) === null || _a === void 0 ? void 0 : _a.map(function (fee) { return ({
            name: fee.name,
            type: fee.type || "FEE",
            description: fee === null || fee === void 0 ? void 0 : fee.description,
            isPrepaid: !!(fee === null || fee === void 0 ? void 0 : fee.is_prepaid),
            displayTotal: transformPrice(fee === null || fee === void 0 ? void 0 : fee.display_total, fee === null || fee === void 0 ? void 0 : fee.display_currency),
        }); }),
    };
}
export function transformHotelReview(data) {
    return mutateReview(data);
}
export function mutateHotelContract(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
    var bookData = data.book_data || data;
    var contractData = data.contract_data || data;
    var hotelData = contractData.hotel_details ||
        contractData.hotel_data || [__assign({}, contractData.hotel)];
    if (contractData.hotel) {
        hotelData[0] = __assign(__assign({}, contractData.hotel), hotelData[0]);
    }
    var roomCount = Number(((_a = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _a === void 0 ? void 0 : _a.num_rooms) ||
        ((_b = contractData === null || contractData === void 0 ? void 0 : contractData.input_data) === null || _b === void 0 ? void 0 : _b.num_rooms));
    var nightsCount = Number(((_c = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _c === void 0 ? void 0 : _c.num_nights) ||
        ((_d = contractData === null || contractData === void 0 ? void 0 : contractData.input_data) === null || _d === void 0 ? void 0 : _d.num_nights));
    var hotels = hotelData.map(function (hotel) {
        return transformHotel(hotel, { nightsCount: nightsCount, roomCount: roomCount });
    });
    var id = (_h = (_g = (_f = (_e = hotels[0]) === null || _e === void 0 ? void 0 : _e.rooms) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.rates) === null || _h === void 0 ? void 0 : _h[0].id;
    var itinerary = bookData === null || bookData === void 0 ? void 0 : bookData.itinerary;
    var bookingID = itinerary === null || itinerary === void 0 ? void 0 : itinerary.id;
    var customer = Array.isArray((_j = bookData === null || bookData === void 0 ? void 0 : bookData.itinerary_details) === null || _j === void 0 ? void 0 : _j.customer)
        ? (_k = bookData === null || bookData === void 0 ? void 0 : bookData.itinerary_details) === null || _k === void 0 ? void 0 : _k.customer[0]
        : (_l = bookData === null || bookData === void 0 ? void 0 : bookData.itinerary_details) === null || _l === void 0 ? void 0 : _l.customer;
    var roomData = (_o = (_m = bookData === null || bookData === void 0 ? void 0 : bookData.itinerary_details) === null || _m === void 0 ? void 0 : _m.room_data) === null || _o === void 0 ? void 0 : _o[0];
    var policyData = roomData === null || roomData === void 0 ? void 0 : roomData.policy_data;
    var address = customer === null || customer === void 0 ? void 0 : customer.address;
    var rate = (_s = (_r = (_q = (_p = hotels === null || hotels === void 0 ? void 0 : hotels[0]) === null || _p === void 0 ? void 0 : _p.rooms) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.rates) === null || _s === void 0 ? void 0 : _s[0];
    var rooms = (((_u = (_t = hotels === null || hotels === void 0 ? void 0 : hotels[0]) === null || _t === void 0 ? void 0 : _t.rooms) === null || _u === void 0 ? void 0 : _u.length) || 0) > 0
        ? (_v = hotels === null || hotels === void 0 ? void 0 : hotels[0]) === null || _v === void 0 ? void 0 : _v.rooms
        : [
            {
                id: (_y = (_x = (_w = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _w === void 0 ? void 0 : _w.room_data) === null || _x === void 0 ? void 0 : _x[0]) === null || _y === void 0 ? void 0 : _y.room_id,
                name: (_z = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _z === void 0 ? void 0 : _z.room_title,
                description: ((_0 = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _0 === void 0 ? void 0 : _0.description) || "",
                size: (data === null || data === void 0 ? void 0 : data.room_square_footage) || 0,
                amenities: [],
                topAmenities: [],
                photos: [],
                bedding: [],
                rates: [],
                occupancyLimit: (itinerary === null || itinerary === void 0 ? void 0 : itinerary.occupancy_limit) || 0,
            },
        ] || [];
    var price = data.price_details
        ? mutateHotelPrice(data.price_details, data.benchmark_price_details, {
            nightsCount: nightsCount,
            roomCount: roomCount,
        })
        : getLowestRatePrice((_1 = hotels === null || hotels === void 0 ? void 0 : hotels[0]) === null || _1 === void 0 ? void 0 : _1.rooms);
    var contract = {
        id: id,
        bundleID: id,
        bookingID: bookingID,
        confirmationNumber: (itinerary === null || itinerary === void 0 ? void 0 : itinerary.confirmation_number) ||
            ((_4 = (_3 = (_2 = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _2 === void 0 ? void 0 : _2.room_data) === null || _3 === void 0 ? void 0 : _3[0]) === null || _4 === void 0 ? void 0 : _4.confirmation_code) ||
            id,
        status: itinerary === null || itinerary === void 0 ? void 0 : itinerary.status,
        hotels: hotels,
        rooms: rooms,
        price: price,
        allowedCreditCards: (_5 = contractData === null || contractData === void 0 ? void 0 : contractData.allowed_cards_data) === null || _5 === void 0 ? void 0 : _5.map(function (card) { return ({
            name: card.name,
            type: card.card_type,
        }); }),
        checkIn: formatURLDate(parsePPNDate(((_6 = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary) === null || _6 === void 0 ? void 0 : _6.check_in) || ((_7 = contractData === null || contractData === void 0 ? void 0 : contractData.input_data) === null || _7 === void 0 ? void 0 : _7.check_in))),
        checkOut: formatURLDate(parsePPNDate(((_8 = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary) === null || _8 === void 0 ? void 0 : _8.check_out) ||
            ((_9 = contractData === null || contractData === void 0 ? void 0 : contractData.input_data) === null || _9 === void 0 ? void 0 : _9.check_out))),
        roomCount: roomCount,
        adultCount: Number(((_10 = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _10 === void 0 ? void 0 : _10.num_adults) ||
            ((_11 = contractData === null || contractData === void 0 ? void 0 : contractData.input_data) === null || _11 === void 0 ? void 0 : _11.num_adults)),
        childCount: Number(((_12 = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _12 === void 0 ? void 0 : _12.num_children) ||
            ((_13 = contractData === null || contractData === void 0 ? void 0 : contractData.input_data) === null || _13 === void 0 ? void 0 : _13.num_children)),
        nightsCount: nightsCount,
        guests: (_15 = (_14 = contractData === null || contractData === void 0 ? void 0 : contractData.itinerary_details) === null || _14 === void 0 ? void 0 : _14.room_data) === null || _15 === void 0 ? void 0 : _15.map(function (roomData) {
            var _a;
            var _b = __read(((_a = roomData.name) === null || _a === void 0 ? void 0 : _a.split(" ")) || ["", ""], 2), firstName = _b[0], lastName = _b[1];
            return {
                firstName: firstName,
                lastName: lastName,
                confirmationCode: roomData.confirmation_code,
            };
        }),
        payment: customer
            ? {
                billing: __assign(__assign({}, mutateAddress(address)), { email: customer.email, phone: {
                        number: customer.phone_number,
                    } }),
                card: {
                    name: customer.name,
                    type: customer.card_type,
                    last4: customer.card_last_four,
                },
            }
            : undefined,
        cancellation: {
            id: (_16 = contractData === null || contractData === void 0 ? void 0 : contractData.actions) === null || _16 === void 0 ? void 0 : _16.cancel,
            price: mutateHotelPrice((_17 = data === null || data === void 0 ? void 0 : data.cancellation_details) === null || _17 === void 0 ? void 0 : _17[0], undefined),
            policy: {
                description: policyData === null || policyData === void 0 ? void 0 : policyData.find(function (_a) {
                    var type = _a.type;
                    return type === "CancelPolicyDescription";
                }).text,
            },
            policies: mutateHotelCancellationPolicies(contractData.cancellation_details) ||
                (rate === null || rate === void 0 ? void 0 : rate.cancellationPolicies),
        },
        policies: (rate === null || rate === void 0 ? void 0 : rate.policies) ||
            parseTextContent((_18 = contractData === null || contractData === void 0 ? void 0 : contractData.important_information) === null || _18 === void 0 ? void 0 : _18.policy_data),
        taxesAndFees: parseTextContent(Array.isArray(data.taxes_and_fees)
            ? data.taxes_and_fees
            : (_19 = data.taxes_and_fees) === null || _19 === void 0 ? void 0 : _19.policy_data),
        isPayLater: !!((_20 = rate === null || rate === void 0 ? void 0 : rate.paymentType) === null || _20 === void 0 ? void 0 : _20.match(/POSTPAID/i)),
        isCancellable: !!(rate === null || rate === void 0 ? void 0 : rate.isCancellable),
        isCancelled: !!((_21 = itinerary === null || itinerary === void 0 ? void 0 : itinerary.status) === null || _21 === void 0 ? void 0 : _21.match(/cancelled/gi)),
        isDeal: (rate === null || rate === void 0 ? void 0 : rate.isMemberDeal) || (rate === null || rate === void 0 ? void 0 : rate.isVIPDeal),
        isMemberDeal: rate === null || rate === void 0 ? void 0 : rate.isMemberDeal,
        isVIPDeal: rate === null || rate === void 0 ? void 0 : rate.isVIPDeal,
        hasBetterDeal: !!(data === null || data === void 0 ? void 0 : data.betterDealAvailable) || !!((_22 = rate === null || rate === void 0 ? void 0 : rate.price) === null || _22 === void 0 ? void 0 : _22.hasBetterDeal),
        __raw__: data,
    };
    return contract;
}
function parseTextContent(data) {
    return ((data === null || data === void 0 ? void 0 : data.map(function (content) {
        return typeof content === "string"
            ? {
                title: "",
                paragraphs: [santizePPNPolicyText(content)],
            }
            : {
                title: content.title || "",
                paragraphs: content.paragraph_data.map(santizePPNPolicyText),
            };
    })) || []);
}
function getRateOptions(rooms) {
    var foundRateOptions = {};
    return rooms.reduce(function (acc, room) {
        var e_4, _a;
        try {
            for (var _b = __values(room.rates), _c = _b.next(); !_c.done; _c = _b.next()) {
                var rate = _c.value;
                if (!foundRateOptions["postpaid"] &&
                    rate.paymentType.match(/postpaid/gi)) {
                    foundRateOptions["postpaid"] = true;
                    acc.push({
                        id: "postpaid",
                        name: "Pay Later",
                        value: "postpaid",
                    });
                }
                if (!foundRateOptions["freeCancellation"] &&
                    (rate.isCancellable || rate.isFullyRefundable)) {
                    foundRateOptions["free-cancellation"] = true;
                    acc.push({
                        id: "free-cancellation",
                        name: "Free Cancellation",
                        value: "free-cancellation",
                    });
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return acc;
    }, []);
}
function getTopAmenities(amenities) {
    return ((amenities === null || amenities === void 0 ? void 0 : amenities.reduce(function (acc, amenity) {
        if (HotelTopAmenities.indexOf(String(amenity.id)) >
            -1) {
            acc.push(amenity);
        }
        return acc;
    }, [])) || []);
}
function getTopBookReasons(hotel) {
    var e_5, _a, e_6, _b;
    var _c, _d;
    var reasons = [];
    if (hotel.hasPayLater) {
        reasons.push("payLater");
    }
    if (hotel.reviewRating > 8) {
        reasons.push("guestsLove");
    }
    if ((((_c = hotel.reviewScores) === null || _c === void 0 ? void 0 : _c.cleanliness) || 0) >= 8) {
        reasons.push("veryClean");
    }
    if ((((_d = hotel.reviewScores) === null || _d === void 0 ? void 0 : _d.location) || 0) > 8) {
        reasons.push("location");
    }
    try {
        for (var _e = __values(hotel.rooms), _f = _e.next(); !_f.done; _f = _e.next()) {
            var room = _f.value;
            try {
                for (var _g = (e_6 = void 0, __values(room.rates)), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var rate = _h.value;
                    if (rate.isFullyRefundable) {
                        reasons.push("refundable");
                        break;
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return reasons;
}
export function flattenHotelRooms(rooms) {
    var e_7, _a;
    var flattened = [];
    var map = {};
    try {
        for (var rooms_1 = __values(rooms), rooms_1_1 = rooms_1.next(); !rooms_1_1.done; rooms_1_1 = rooms_1.next()) {
            var room = rooms_1_1.value;
            var existing = map[room.id] || map[room.name];
            var id = (existing === null || existing === void 0 ? void 0 : existing.id) || room.id;
            var flattenedRoom = __assign(__assign({}, (existing || room)), { id: id, rates: __spreadArray(__spreadArray([], __read(((existing === null || existing === void 0 ? void 0 : existing.rates) || [])), false), __read((room.rates || [])), false) });
            map[id] = map[room.name] = flattenedRoom;
            if (!existing) {
                flattened.push(id);
            }
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (rooms_1_1 && !rooms_1_1.done && (_a = rooms_1.return)) _a.call(rooms_1);
        }
        finally { if (e_7) throw e_7.error; }
    }
    var flattenedRooms = flattened
        .map(function (id) {
        var room = map[id];
        return __assign(__assign({}, room), { rates: room.rates
                .filter(function (rate) {
                var _a, _b;
                return (((_a = rate.price.display) === null || _a === void 0 ? void 0 : _a.value) || 0) > 0 &&
                    (((_b = rate.price.displayTotal) === null || _b === void 0 ? void 0 : _b.value) || 0) > 0;
            })
                .sort(function (a, b) {
                var _a, _b;
                return (((_a = a.price.displayTotal) === null || _a === void 0 ? void 0 : _a.value) || 0) -
                    (((_b = b.price.displayTotal) === null || _b === void 0 ? void 0 : _b.value) || 0);
            }) || [] });
    })
        .filter(function (room) { return room.rates.length > 0; });
    return flattenedRooms;
}
var ignore = ["discountType", "hasBetterDeal", "isDiscount", "mandatoryFees"];
//@TODO: Refactor to remove these entirely. Adopt the this structure
//       throughout the app instead
export function serializeHotel(hotel) {
    var _a, _b, _c;
    var currencyType = ((_c = (_b = (_a = hotel.price) === null || _a === void 0 ? void 0 : _a.display) === null || _b === void 0 ? void 0 : _b.currency) === null || _c === void 0 ? void 0 : _c.type) || "usd";
    var prices = Object.entries(hotel.price).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (ignore.indexOf(key) > -1) {
            acc[key] = value;
        }
        else {
            var price = (value === null || value === void 0 ? void 0 : value.value) || 0;
            if (price > 0) {
                acc[key] = price;
            }
        }
        return acc;
    }, {});
    return __assign(__assign({}, hotel), { price: __assign({ currency: currencyType }, prices) });
}
export function deserializeHotel(hotel) {
    var _a;
    var currency = CurrencyMap[(_a = hotel.price) === null || _a === void 0 ? void 0 : _a.currency];
    if (!currency) {
        // Probably doesn't have searialized interface...
        return hotel;
    }
    else {
        // Add back in bulky data for legacy. See the above @TODO
        var price = Object.entries(hotel.price).reduce(function (acc, _a) {
            var _b = __read(_a, 2), name = _b[0], value = _b[1];
            if (ignore.indexOf(name) > -1) {
                acc[name] = value;
            }
            else {
                if (value > 0) {
                    acc[name] = {
                        currency: currency,
                        value: value,
                    };
                }
            }
            return acc;
        }, {});
        return __assign(__assign({}, hotel), { price: price });
    }
}
